<template>
    <div class="container">

        <div class="container mt-4">
            <!-- شريط التنقل -->
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a href="index.html" class="text-decoration-none">
                            <i class="bi bi-house-door-fill"></i>
                        </a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{ $t('Detailes') }}</li>
                </ol>
            </nav>
        </div>
        <form autocomplete="false" @submit.prevent="submitInfo" @keydown="form.onKeydown($event)">
            <div class="row o_portal_details">
                <div class="col-lg-8">
                    <div class="row">
                        <input type="hidden" name="csrf_token"
                            value="2daaf02cb495054faffcc248115ed2f8c4d59aedo1770219254">
                        <div class="form-group  col-xl-12">
                            <label class="col-form-label" for="name">{{ $t('name') }}</label>
                            <input type="text" name="name" class="form-control " v-model="form.name" required>
                        </div>
                        <div class="mb-3  col-xl-6">
                            <label class="col-form-label" for="email">{{ $t('phone') }}</label>
                            <input type="text" name="phone" class="form-control " required
                                :minlength=$store.state.country_length :maxlength=$store.state.country_length
                                autocomplete="false" v-model="form.phone" placeholder="xxxx xxxx">
                        </div>

                          <div class="mb-3  col-xl-6">
                            <label class="col-form-label" for="email">{{ $t('email') }}</label>
                            <input type="text" name="phone" class="form-control " required
                               
                                autocomplete="false" v-model="form.email"  reedonly>
                        </div>


                        <div class="form-group  col-xl-12
    "></div>

                        <input type="hidden" name="redirect">
                    </div>
                    <div class="clearfix">
                        <button  
                         type="submit"
                    :disabled="form.busy"
                        class="btn_cart_check">
                            {{ $t('confirm') }}
                            <span class="fa fa-long-arrow-right"></span>
                                            <i class="fa fa-spinner fa-spin " v-if="loading"></i>

                        </button>
                    </div>
                </div>
            </div>
        </form>



  <div v-if="errorMessage" style="
  position: fixed;
  z-index: 100;
  width: 320px;
  top: 10%;
  left: 50px;
  border-radius: 8px;
  background-color: white;
  border: 2px solid var(--primary-color);
  text-align: center;
  padding: 10px;
  color: black;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
">

            <p style="margin-top: 10px;">{{ errorMessage }}</p>
            
        </div>
    </div>

</template>


<script>
//import testImage from "../../public/assets/image/icons/defult.svg";
import Form from "vform";

import CodeInput from "vue-verification-code-input";

import Vodal from "vodal";

import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";
import "vodal/slide-left.css";

export default {
    components: {
        Vodal,
        CodeInput
    },
    data: function () {
        return {
            //DBitems: null,
            forgetVodal: false,
            codeVodal: false,
            newPassVodal: false,
             loading:false,
            errorMessageVodal: "",
            passemail: "",
            Newpassword: null,
            checkcomplete: false,
            finalcode: null,
            phone: null,
            errorMessage: "",
            form: new Form({
                //preview: testImage,
                email: null,
                name: null,
                phone: null,
            })
        };
    },
    created() {
        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/profile",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization:
                            "Bearer " + this.$localStorage.get(this.$store.storeName)
                    }
                }
            )
            .then(response => {
                this.form.email = response.data.data.email;
                this.form.name = response.data.data.name;
                this.phone = response.data.data.phone.substr(4);
                console.log('phone ' + this.phone);
                //console.log(this.form)
            })
            .catch(error => {
                if (error.response.status == "401") {
                    this.$localStorage.remove(this.$store.storeName);
                    window.location.href =
                        "/";
                }
            });
        if (this.$i18n.locale == 'ar') {
            document.title = this.$store.state.title_ar;
            document.getElementById("description_meta").content = this.$store.state.description_ar;
            document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
        }
        else {
            document.title = this.$store.state.title_en;
            document.getElementById("description_meta").content = this.$store.state.description_en;
            document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
        }
    },
    methods: {
        /*readURL(e) {
          this.preview = URL.createObjectURL(e.target.files[0]);
        },*/
        async submitInfo() {
        this.loading=true
            this.form.phone = this.$store.state.country_code + this.phone;

            const response = await this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/profile/update",
                    {
                        email: this.form.email,
                        name: this.form.name,
                        phone: this.form.phone
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                     this.loading=false
                    if (response.data.code == "1") {
                        this.errorMessage = response.data.message;
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    } else if (response.data.code == "-1") {
                        this.errorMessage = response.data.message;
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    }
                    if (response.data.error) {
                        this.errorMessage = response.data.error;
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    }
                })
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";
                    }
                });
        },
        resetpass(type) {
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/reset_password",
                    {
                        ///update_password
                        send_type: type
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    if (response.data.code == "1") {
                        this.forgetVodal = false;
                        this.codeVodal = true;
                        // console.log(response.data.message);
                    } else if (response.data.code == "-1") {
                        this.errorMessageVodal = response.data.message;
                        setTimeout(() => {
                            this.errorMessageVodal = "";
                        }, 3000);
                    }
                    if (response.data.error) {
                        this.errorMessageVodal = response.data.message;
                        setTimeout(() => {
                            this.errorMessageVodal = "";
                        }, 3000);
                    }
                })
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";
                    }
                });
        },
        checkCode() {
            if (this.checkcomplete == true) {
                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/verivey_reset_password",
                        {
                            ///update_password
                            code: this.finalcode
                        },
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale,
                                Authorization:
                                    "Bearer " + this.$localStorage.get(this.$store.storeName)
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.code == "1") {
                            this.forgetVodal = false;
                            this.codeVodal = false;
                            this.newPassVodal = true;
                            // console.log(response.data.message);
                        } else if (response.data.code == "-1") {
                            this.errorMessageVodal = response.data.message;
                            setTimeout(() => {
                                this.errorMessageVodal = "";
                            }, 3000);
                        }
                        if (response.data.error) {
                            this.errorMessageVodal = response.data.message;
                            setTimeout(() => {
                                this.errorMessageVodal = "";
                            }, 3000);
                        }
                    })
                    .catch(error => {
                        if (error.response.status == "401") {
                            this.$localStorage.remove(this.$store.storeName);
                            window.location.href =
                                "/";
                        }
                    });
            } else {
                if (this.$i18n.locale == "en") {
                    this.errorMessageVodal = "your code isn't complete";
                    setTimeout(() => {
                        this.errorMessageVodal = "";
                    }, 3000);
                } else {
                    this.errorMessageVodal = "الرمز المدخل غير مكتمل";
                    setTimeout(() => {
                        this.errorMessageVodal = "";
                    }, 3000);
                }
            }
        },
        SaveChanges() {
            if (this.Newpassword != null) {
                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/auth/update_password",
                        {
                            ///update_password
                            password: this.Newpassword
                        },
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale,
                                Authorization:
                                    "Bearer " + this.$localStorage.get(this.$store.storeName)
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.code == "1") {
                            this.forgetVodal = false;
                            this.codeVodal = false;
                            this.newPassVodal = false;
                            // console.log(response.data.message);
                        } else if (response.data.code == "-1") {
                            this.errorMessageVodal = response.data.message;
                            setTimeout(() => {
                                this.errorMessageVodal = "";
                            }, 3000);
                        }
                        if (response.data.error) {
                            this.errorMessageVodal = response.data.message;
                            setTimeout(() => {
                                this.errorMessageVodal = "";
                            }, 3000);
                        }
                    })
                    .catch(error => {
                        if (error.response.status == "401") {
                            this.$localStorage.remove(this.$store.storeName);
                            window.location.href =
                                "/";
                        }
                    });
            } else {
                this.errorMessageVodal = "error";
                setTimeout(() => {
                    this.errorMessageVodal = "";
                }, 3000);
            }
        },
        onChange(v) {
            //console.log("onChange ", this.phone);
            this.checkcomplete = false;
        },
        onComplete(v) {
            //console.log("onComplete ", v);
            this.finalcode = v;
            this.checkcomplete = true;
        }
    }
};
</script>